var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpacing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.5C13 3.94772 13.4477 3.5 14 3.5H21C21.5523 3.5 22 3.94772 22 4.5C22 5.05228 21.5523 5.5 21 5.5H14C13.4477 5.5 13 5.05228 13 4.5Z",
    fill: "#52525B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.5C6 19.0523 6.4477 19.5 7 19.5C7.5523 19.5 8 19.0523 8 18.5V6.9142L9.2929 8.2071C9.6834 8.5976 10.3166 8.5976 10.7071 8.2071C11.0976 7.8166 11.0976 7.1834 10.7071 6.7929L7.7071 3.79289C7.5196 3.60536 7.2652 3.5 7 3.5C6.7348 3.5 6.4804 3.60536 6.2929 3.79289L3.2929 6.7929C2.90237 7.1834 2.90237 7.8166 3.2929 8.2071C3.6834 8.5976 4.3166 8.5976 4.7071 8.2071L6 6.9142V18.5Z",
    fill: "#52525B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.5C6 6.9477 6.4477 6.5 7 6.5C7.5523 6.5 8 6.9477 8 7.5V17.0858L9.2929 15.7929C9.6834 15.4024 10.3166 15.4024 10.7071 15.7929C11.0976 16.1834 11.0976 16.8166 10.7071 17.2071L7.7071 20.2071C7.5196 20.3946 7.2652 20.5 7 20.5C6.7348 20.5 6.4804 20.3946 6.2929 20.2071L3.2929 17.2071C2.90237 16.8166 2.90237 16.1834 3.2929 15.7929C3.6834 15.4024 4.3166 15.4024 4.7071 15.7929L6 17.0858V7.5Z",
    fill: "#52525B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.5C13 8.94772 13.4477 8.5 14 8.5H21C21.5523 8.5 22 8.94772 22 9.5C22 10.0523 21.5523 10.5 21 10.5H14C13.4477 10.5 13 10.0523 13 9.5Z",
    fill: "#52525B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.5C13 13.9477 13.4477 13.5 14 13.5H21C21.5523 13.5 22 13.9477 22 14.5C22 15.0523 21.5523 15.5 21 15.5H14C13.4477 15.5 13 15.0523 13 14.5Z",
    fill: "#52525B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.5C13 18.9477 13.4477 18.5 14 18.5H21C21.5523 18.5 22 18.9477 22 19.5C22 20.0523 21.5523 20.5 21 20.5H14C13.4477 20.5 13 20.0523 13 19.5Z",
    fill: "#52525B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacing);
export default __webpack_public_path__ + "static/media/Spacing.94efe52d1f7f7430a15facec82f16dc8.svg";
export { ForwardRef as ReactComponent };